import i18n from '@/utils/i18n';
import React from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { EmptyState } from '@experiences/components/empty-state';

interface Props {
  clearLabel?: string;
  description?: string;
  onClearSearch: () => void;
  title?: string;
}

export const PricingSearchEmptyState: React.FC<Props> = ({
  clearLabel = i18n.t('clear_filters'),
  description = i18n.t('pricing.no_results.description'),
  onClearSearch,
  title = '',
}) => (
  <EmptyState
    bottomElement={
      <Button
        accessibilityLabel={clearLabel}
        onPress={onClearSearch}
        size={ButtonSize.Medium}
        variant={ButtonVariant.Secondary}
        width={120}
      >
        {clearLabel}
      </Button>
    }
    description={description}
    iconElement={null}
    title={title}
  />
);
